import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_9: FaireProductEntity = {
  token: "casa-bosques-9",
  type: "product",
  name: "Meadow Land Incense Cones",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0df6f03900eccfb61f09216b82f305c98fd7a5cbd623880a66ab7eae38371801.webp",
  priceDollars: 18,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
